import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Healthcaremilo() {
  return (
    <section className="web_visibility p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center resp_order mt-4 mt-md-0"
          >
            <StaticImage
              src="../../images/services-usa/hire_react/hire_ranked.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={761}
              height={720}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Hire Top-ranked ReactJS Developers <span>with TekRevol</span>
            </h2>
            <p>
              Hire ReactJS developers from Radixweb to create high-performance,
              interactive, and user-friendly web applications. Our team offers
              comprehensive ReactJS development expertise, including JSX, core
              JavaScript, Git, Redux, and more.
            </p>
            <p>
              Save up to 40% on development, support, and maintenance costs by
              hiring our ReactJS developers. Benefit from efficient, next-gen
              front-end applications while saving valuable time.
            </p>
            <p>
              Our ReactJS development covers cross-platform web applications and
              mobile SPAs, ensuring enhanced user impact, appeal, and brand
              presence.
            </p>
            <p>
              So, choose TekRevol for innovative and successful hire resourceful
              ReactJS developers that drive your business forward.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Discuss Your Project!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Healthcaremilo;
